import FrenchPage from '../components/lifecycle/FrenchPage';
import InsideHeadFR from '../components/inside/InsideHeadFR';
import InsideHouse from './InsideHouse';

export default function InsideHouseFR() {
  return (
    <>
      <FrenchPage />
      <InsideHeadFR />
      <InsideHouse />
    </>
  );
}